<re-alert *ngIf="successAlert" [type]="successAlert.type" (close)="successAlert = null">{{ successAlert.message }}</re-alert>
<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>

<h1>Parameter Details</h1>

<div *ngIf="parameterId">
  <div style="font-weight:bold">Parameter Name</div>
  <div>{{parameter.key}}</div>
</div>
<button (click)="goBack()" *ngIf="!editProfile && parameterId!=0" class="btn btn-default afterDiv">Back</button>

<fieldset [disabled]="isReadOnlyUser ? 'disabled' : null">
<form [formGroup]="parameterDetailForm" id="parameterDetailForm">
  <div class="row">
    <div class="col-12 mb-4">
      <div class="card bg-light">
        <div class="card-header">
          <h4 class="mb-0">Server Parameters Details</h4>
        </div>
        <div class="card-body">

          <!-- Action Buttons -->
          <div class="row">
            <div class="col-12">
              <div class="form-group mb-4">
                <button class="btn btn-default" *ngIf="!editProfile" (click)="editProfileClicked()">Edit Details</button>
                <button class="btn btn-success" *ngIf="editProfile" [disabled]="!parameterDetailForm.valid" (click)="updateParameter()">Save</button>
                <button class="btn btn-cancel" *ngIf="editProfile" (click)="resetFlags()">Cancel</button>
                <button class="btn btn-danger" *ngIf="!editProfile" (click)="deleteParameter()">Delete Parameter</button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-1 form-group" *ngIf="parameterId">
              <label for="parameterId">ID</label>
              <input type="text" id="parameterId" formControlName="id" [readonly]="true" [ngClass]="{'form-control-plaintext':true}">
            </div>

            <div class="col-12 col-sm-6 col-md-4 form-group input-required">
              <label for="parameterKey">Key</label>
              <input formControlName="key" id="parameterKey" type="text" [readonly]="!editProfile" [ngClass]="{'form-control': editProfile, 'form-control-plaintext': !editProfile}" (input)="this.parameter.value=checkDefaultText()">
              <small *ngIf="parameterDetailForm.controls['key'].hasError('blank') && parameterDetailForm.controls['key'].touched" class="text-danger">Please enter the Key.</small>
            </div>

            <div class="col-12 col-sm-6 col-md-4 form-group input-required" *ngIf="checkSelect()">
              <div class="form-group">
                <label for="parameterValue">Value</label>
                <span [ngClass]="{'form-control': editProfile, 'form-control-plaintext': !editProfile}" *ngIf="!editProfile && !gsEnabled">{{parameterService.getEnabledDisableText(parameter.value)}}</span>
                <span [ngClass]="{'form-control': editProfile, 'form-control-plaintext': !editProfile}" *ngIf="!editProfile && gsEnabled">{{parameterService.getGSDisplayText(parameter.value)}}</span>
                <select2 *ngIf="editProfile && !gsEnabled" [(ngModel)]="parameter.value" [settings]="{placeholder: 'False',width:'100%', minimumResultsForSearch: -1}" formControlName="value" [options]="enabledDisableData"></select2>
                <select2 *ngIf="editProfile && gsEnabled" [(ngModel)]="parameter.value" [settings]="{placeholder: 'First Name &quot;Preferred Name&quot; Last Name',width:'100%', minimumResultsForSearch: -1}" formControlName="value" [options]="gsEnabledData"></select2>
                <small *ngIf="parameterDetailForm.controls['value']?.errors?.error && parameterDetailForm.touched" class="text-danger">{{parameterDetailForm.controls['value'].errors?.message}}</small>
                <!--<small *ngIf="editProfile && parameterDetailForm.controls['value'].hasError('gsDependency') && (parameterDetailForm.controls['value'].dirty || parameterDetailForm.controls['value'].touched)" class="text-danger">Search requires SNF URL and corpOID parameters. Unable to activate Search.</small>
              --></div>
            </div>

            <div class="col-7 col-sm-6 col-md-4 form-group input-required" *ngIf="!checkSelect()">
              <label for="parameterValue">Value</label>
              <input formControlName="value" id="parameterValue" type="text" [readonly]="!editProfile" [ngClass]="{'form-control': editProfile, 'form-control-plaintext': !editProfile}">

              <small *ngIf="parameterDetailForm.controls['value']?.errors?.error && parameterDetailForm.touched" class="text-danger">{{parameterDetailForm.controls['value'].errors?.message}}</small>
              <!--<small *ngIf="editProfile && parameterDetailForm.controls['value'].hasError('blank') && (parameterDetailForm.controls['value'].dirty || parameterDetailForm.controls['value'].touched)" class="text-danger">Please enter the Value.</small>
              <small *ngIf="editProfile && parameterDetailForm.controls['value'].hasError('hasEmptySpace') && (parameterDetailForm.controls['value'].dirty || parameterDetailForm.controls['value'].touched)" class="text-danger">Spaces are not allowed.</small>
              <small *ngIf="editProfile && parameterDetailForm.controls['value'].hasError('incorrectScheme') && (parameterDetailForm.controls['value'].dirty || parameterDetailForm.controls['value'].touched)" class="text-danger">URL must start with http:// or https://.</small>
              <small *ngIf="editProfile && parameterDetailForm.controls['value'].hasError('hasNonNumeric') && (parameterDetailForm.controls['value'].dirty || parameterDetailForm.controls['value'].touched)" class="text-danger">Only numeric value is allowed.</small>
            --></div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!-- <div class="row">
      <div class="col-12 mb-4">
        <div class="card bg-light">
          <div class="card-header">
            <h4 class="mb-0">Configurations</h4>
          </div>
          <a *ngFor="let config of configurations" [routerLink]="['/ect/configurations/detail',config.id]" class="list-group-item list-group-item-action flex-column">
            <div class="d-flex justify-content-between">
              {{config.configName}}
            </div>
          </a>
        </div>
      </div>
    </div> -->


</form>
</fieldset>
